const t = {
  fr: {
    facturation: 'Facturation', clients: 'Clients', crm: 'CRM', settings: 'Paramètres',
    facture: 'Facture', nouvelleFacture: 'Nouvelle facture',
    votre_entreprise: 'Votre entreprise', nom_entreprise: "Nom de l'entreprise",
    infos_client: 'Informations client', nom_client: 'Nom du client',
    adresse: 'Adresse', email: 'Email', telephone: 'Téléphone',
    details_facture: 'Détails de la facture', numero_facture: 'Numéro de facture',
    date_emission: "Date d'émission", date_echeance: "Date d'échéance",
    articles: 'Articles / Services', description: 'Description',
    quantite: 'Quantité', prix_unit: 'Prix unit.', total: 'Total',
    ajouter_article: 'Ajouter un article', tva: 'TVA (%)',
    notes: 'Notes / Conditions de paiement', sous_total: 'Sous-total HT',
    total_ttc: 'TOTAL TTC', marquer_payee: 'Marquer payée', marquer_impayee: 'Marquer impayée',
    apercu: 'Aperçu', telecharger_pdf: 'Télécharger PDF', choisir_client: 'Choisir un client',
    devise: 'Devise', rechercher_client: 'Rechercher un client...',
    tous: 'Tous', particuliers: 'Particuliers', societes: 'Sociétés',
    nouveau_client: 'Nouveau client', total_clients: 'Total clients',
    aucun_client: 'Aucun client trouvé', ajouter_client: 'Ajouter un client',
    modifier: 'Modifier', supprimer: 'Supprimer', annuler: 'Annuler', enregistrer: 'Enregistrer',
    opportunites: 'Opportunités', activites: 'Activités', ajouter: 'Ajouter',
    nouvelle_opportunite: 'Nouvelle opportunité', intitule: 'Intitulé',
    montant_ht: 'Montant HT', mois_signature: 'Mois de signature prévu',
    statut: 'Statut', destinataire: 'Destinataire', creer_opportunite: "Créer l'opportunité",
    tous_opp: 'Tous', remportees: 'Remportées', perdues: 'Perdues',
    aucune_activite: "Aucune activité pour l'instant",
    parametres: 'Paramètres', langue: 'Langue',
    choisir_langue: "Choisir la langue de l'application",
    devise_defaut: 'Devise par défaut',
    choisir_devise: "Devise utilisée dans toute l'application",
    sauvegarder: 'Sauvegarder',
    client_cree: 'Client créé avec succès !', client_modifie: 'Client modifié avec succès !',
    client_supprime: 'Client supprimé !', opp_creee: 'Opportunité créée avec succès !',
    pdf_telecharge: 'PDF téléchargé !', parametres_sauvegardes: 'Paramètres sauvegardés !',
    erreur_chargement: 'Erreur lors du chargement',
    erreur_sauvegarde: 'Erreur lors de la sauvegarde',
    erreur_suppression: 'Erreur lors de la suppression',
    // Dashboard & navigation
    dashboard: 'Dashboard', bienvenue: 'Bienvenue', docs_par_jour: 'Documents / Jour',
    creer_document: 'Créer un Document', choisir_type: 'Choisissez le type de document à générer',
    nouvelle_facture: 'Nouvelle Facture', nouveau_cv: 'Nouveau CV',
    factures_creees: 'Factures créées', cvs_generes: 'CV générés',
    total_telechargements: 'Total Téléchargements', productivite: 'PRODUCTIVITÉ',
    taux_utilisation: "Taux d'utilisation", docs_totaux: 'Documents Totaux',
    tendance_mensuelle: 'Tendance Mensuelle', actions_rapides: 'Actions Rapides',
    facture_pro: 'Créez une facture professionnelle', cv_ats: 'CV optimisé ATS',
    configurer_compte: 'Configurez votre compte', guide: "Guide d'utilisation",
    documentation: 'Documentation', parametres_nav: 'Paramètres',
    compte_connecte: 'Compte Connecté', notifications: 'Notifications',
    aucune_notification: 'Aucune notification', tout_effacer: 'Tout effacer',
    deconnexion: 'Déconnexion', deconnexion_confirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    se_deconnecter: 'Se déconnecter', factures_nav: 'Factures', cv_nav: 'CV',
    administration: 'Administration', utilisateurs: 'Utilisateurs',
    documents_nav: 'Documents', statistiques: 'Statistiques',
    acces_admin: 'Accès Admin',
    gerer_users_docs: 'Gérez les utilisateurs, documents et statistiques globales',
    rechercher_utilisateur: 'Rechercher un utilisateur...',
    rechercher_document: 'Rechercher un document ou un email...',
    utilisateur: 'Utilisateur', role: 'Rôle', inscription: 'Inscription',
    actions: 'Actions', fichier: 'Fichier', type: 'Type',
    proprietaire: 'Propriétaire', date: 'Date',
    aucun_utilisateur: 'Aucun utilisateur trouvé',
    aucun_document_admin: 'Aucun document trouvé', chargement: 'Chargement...',
    succes: 'Succès', erreur: 'Erreur', attention: 'Attention', information: 'Information',
    deconnexion_titre: 'Déconnexion', changer_mdp: 'Changer le mot de passe',
    mdp_actuel: 'Mot de passe actuel', nouveau_mdp: 'Nouveau mot de passe',
    confirmer_mdp: 'Confirmer le mot de passe', activer_2fa: 'Activer 2FA',
    historique_connexion: 'Historique de connexion', fermer: 'Fermer',
    cv_etape1: 'Mon CV',
    cv_etape2: 'Offre & IA',
    cv_etape3: 'Aperçu & Export',
    cv_titre: 'CV Intelligent',
    cv_sous_titre: 'Créez votre CV optimisé ATS',
    cv_infos_perso: 'Informations personnelles',
    cv_nom: 'Nom complet',
    cv_poste: 'Poste visé',
    cv_tel: 'Téléphone',
    cv_ville: 'Ville',
    cv_pays: 'Pays',
    cv_linkedin: 'LinkedIn',
    cv_resume: 'Résumé professionnel',
    cv_experiences: 'Expériences',
    cv_ajouter_exp: 'Ajouter une expérience',
    cv_formations: 'Formations',
    cv_ajouter_form: 'Ajouter une formation',
    cv_competences: 'Compétences',
    cv_langues_cv: 'Langues parlées',
    cv_template: 'Template',
    cv_couleur: 'Couleur',
    cv_police: 'Police',
    cv_telecharger: 'Télécharger PDF',
    cv_telecharger_word: 'Télécharger Word',
    cv_suivant: 'Suivant',
    cv_precedent: 'Précédent',
    cv_offre_emploi: "Offre d'emploi",
    cv_analyser: 'Analyser & Adapter',
    cv_analyse_ia: 'Analyse IA',
  },

  en: {
    facturation: 'Billing', clients: 'Clients', crm: 'CRM', settings: 'Settings',
    facture: 'Invoice', nouvelleFacture: 'New invoice',
    votre_entreprise: 'Your company', nom_entreprise: 'Company name',
    infos_client: 'Client information', nom_client: 'Client name',
    adresse: 'Address', email: 'Email', telephone: 'Phone',
    details_facture: 'Invoice details', numero_facture: 'Invoice number',
    date_emission: 'Issue date', date_echeance: 'Due date',
    articles: 'Items / Services', description: 'Description',
    quantite: 'Qty', prix_unit: 'Unit price', total: 'Total',
    ajouter_article: 'Add item', tva: 'VAT (%)',
    notes: 'Notes / Payment terms', sous_total: 'Subtotal',
    total_ttc: 'TOTAL', marquer_payee: 'Mark as paid', marquer_impayee: 'Mark as unpaid',
    apercu: 'Preview', telecharger_pdf: 'Download PDF', choisir_client: 'Choose a client',
    devise: 'Currency', rechercher_client: 'Search client...',
    tous: 'All', particuliers: 'Individuals', societes: 'Companies',
    nouveau_client: 'New client', total_clients: 'Total clients',
    aucun_client: 'No client found', ajouter_client: 'Add a client',
    modifier: 'Edit', supprimer: 'Delete', annuler: 'Cancel', enregistrer: 'Save',
    opportunites: 'Opportunities', activites: 'Activities', ajouter: 'Add',
    nouvelle_opportunite: 'New opportunity', intitule: 'Title',
    montant_ht: 'Amount (excl. tax)', mois_signature: 'Expected signing month',
    statut: 'Status', destinataire: 'Recipient', creer_opportunite: 'Create opportunity',
    tous_opp: 'All', remportees: 'Won', perdues: 'Lost', aucune_activite: 'No activities yet',
    parametres: 'Settings', langue: 'Language',
    choisir_langue: 'Choose the application language',
    devise_defaut: 'Default currency', choisir_devise: 'Currency used throughout the app',
    sauvegarder: 'Save',
    client_cree: 'Client created successfully!', client_modifie: 'Client updated successfully!',
    client_supprime: 'Client deleted!', opp_creee: 'Opportunity created successfully!',
    pdf_telecharge: 'PDF downloaded!', parametres_sauvegardes: 'Settings saved!',
    erreur_chargement: 'Loading error', erreur_sauvegarde: 'Save error',
    erreur_suppression: 'Delete error',
    dashboard: 'Dashboard', bienvenue: 'Welcome', docs_par_jour: 'Docs / Day',
    creer_document: 'Create a Document', choisir_type: 'Choose the document type to generate',
    nouvelle_facture: 'New Invoice', nouveau_cv: 'New CV',
    factures_creees: 'Invoices created', cvs_generes: 'CVs generated',
    total_telechargements: 'Total Downloads', productivite: 'PRODUCTIVITY',
    taux_utilisation: 'Usage rate', docs_totaux: 'Total Documents',
    tendance_mensuelle: 'Monthly Trend', actions_rapides: 'Quick Actions',
    facture_pro: 'Create a professional invoice', cv_ats: 'ATS-optimized CV',
    configurer_compte: 'Configure your account', guide: 'User guide',
    documentation: 'Documentation', parametres_nav: 'Settings',
    compte_connecte: 'Connected Account', notifications: 'Notifications',
    aucune_notification: 'No notifications', tout_effacer: 'Clear all',
    deconnexion: 'Logout', deconnexion_confirm: 'Are you sure you want to log out?',
    se_deconnecter: 'Log out', factures_nav: 'Invoices', cv_nav: 'CV',
    administration: 'Administration', utilisateurs: 'Users',
    documents_nav: 'Documents', statistiques: 'Statistics',
    acces_admin: 'Admin Access',
    gerer_users_docs: 'Manage users, documents and global statistics',
    rechercher_utilisateur: 'Search user...', rechercher_document: 'Search document or email...',
    utilisateur: 'User', role: 'Role', inscription: 'Registered',
    actions: 'Actions', fichier: 'File', type: 'Type', proprietaire: 'Owner', date: 'Date',
    aucun_utilisateur: 'No user found', aucun_document_admin: 'No document found',
    chargement: 'Loading...', succes: 'Success', erreur: 'Error',
    attention: 'Warning', information: 'Information',
    deconnexion_titre: 'Logout', changer_mdp: 'Change password',
    mdp_actuel: 'Current password', nouveau_mdp: 'New password',
    confirmer_mdp: 'Confirm password', activer_2fa: 'Enable 2FA',
    historique_connexion: 'Login history', fermer: 'Close',
    //CV
    cv_etape1: 'My CV', cv_etape2: 'Job Offer & AI', cv_etape3: 'Preview & Export',
    cv_titre: 'Smart CV', cv_sous_titre: 'Create your ATS-optimized CV',
    cv_infos_perso: 'Personal information', cv_nom: 'Full name', cv_poste: 'Target position',
    cv_tel: 'Phone', cv_ville: 'City', cv_pays: 'Country', cv_linkedin: 'LinkedIn',
    cv_resume: 'Professional summary', cv_experiences: 'Experience',
    cv_ajouter_exp: 'Add experience', cv_formations: 'Education',
    cv_ajouter_form: 'Add education', cv_competences: 'Skills',
    cv_langues_cv: 'Languages', cv_template: 'Template', cv_couleur: 'Color',
    cv_police: 'Font', cv_telecharger: 'Download PDF', cv_telecharger_word: 'Download Word',
    cv_suivant: 'Next', cv_precedent: 'Previous', cv_offre_emploi: 'Job offer',
    cv_analyser: 'Analyze & Adapt', cv_analyse_ia: 'AI Analysis',
  },

  es: {
    facturation: 'Facturación', clients: 'Clientes', crm: 'CRM', settings: 'Ajustes',
    facture: 'Factura', nouvelleFacture: 'Nueva factura',
    votre_entreprise: 'Tu empresa', nom_entreprise: 'Nombre de la empresa',
    infos_client: 'Información del cliente', nom_client: 'Nombre del cliente',
    adresse: 'Dirección', email: 'Correo electrónico', telephone: 'Teléfono',
    details_facture: 'Detalles de la factura', numero_facture: 'Número de factura',
    date_emission: 'Fecha de emisión', date_echeance: 'Fecha de vencimiento',
    articles: 'Artículos / Servicios', description: 'Descripción',
    quantite: 'Cant.', prix_unit: 'Precio unit.', total: 'Total',
    ajouter_article: 'Agregar artículo', tva: 'IVA (%)',
    notes: 'Notas / Condiciones de pago', sous_total: 'Subtotal',
    total_ttc: 'TOTAL', marquer_payee: 'Marcar como pagada',
    marquer_impayee: 'Marcar como impagada', apercu: 'Vista previa',
    telecharger_pdf: 'Descargar PDF', choisir_client: 'Elegir un cliente',
    devise: 'Moneda', rechercher_client: 'Buscar cliente...',
    tous: 'Todos', particuliers: 'Particulares', societes: 'Empresas',
    nouveau_client: 'Nuevo cliente', total_clients: 'Total clientes',
    aucun_client: 'No se encontró ningún cliente', ajouter_client: 'Agregar cliente',
    modifier: 'Editar', supprimer: 'Eliminar', annuler: 'Cancelar', enregistrer: 'Guardar',
    opportunites: 'Oportunidades', activites: 'Actividades', ajouter: 'Agregar',
    nouvelle_opportunite: 'Nueva oportunidad', intitule: 'Título',
    montant_ht: 'Importe (sin impuestos)', mois_signature: 'Mes de firma previsto',
    statut: 'Estado', destinataire: 'Destinatario', creer_opportunite: 'Crear oportunidad',
    tous_opp: 'Todos', remportees: 'Ganadas', perdues: 'Perdidas',
    aucune_activite: 'No hay actividades todavía',
    parametres: 'Ajustes', langue: 'Idioma',
    choisir_langue: 'Elige el idioma de la aplicación',
    devise_defaut: 'Moneda predeterminada',
    choisir_devise: 'Moneda utilizada en toda la aplicación',
    sauvegarder: 'Guardar',
    client_cree: '¡Cliente creado con éxito!', client_modifie: '¡Cliente modificado con éxito!',
    client_supprime: '¡Cliente eliminado!', opp_creee: '¡Oportunidad creada con éxito!',
    pdf_telecharge: '¡PDF descargado!', parametres_sauvegardes: '¡Ajustes guardados!',
    erreur_chargement: 'Error de carga', erreur_sauvegarde: 'Error al guardar',
    erreur_suppression: 'Error al eliminar',
    dashboard: 'Panel', bienvenue: 'Bienvenido', docs_par_jour: 'Documentos / Día',
    creer_document: 'Crear documento', choisir_type: 'Elige el tipo de documento',
    nouvelle_facture: 'Nueva factura', nouveau_cv: 'Nuevo CV',
    factures_creees: 'Facturas creadas', cvs_generes: 'CVs generados',
    total_telechargements: 'Total descargas', productivite: 'PRODUCTIVIDAD',
    taux_utilisation: 'Tasa de uso', docs_totaux: 'Total documentos',
    tendance_mensuelle: 'Tendencia mensual', actions_rapides: 'Acciones rápidas',
    facture_pro: 'Crea una factura profesional', cv_ats: 'CV optimizado ATS',
    configurer_compte: 'Configura tu cuenta', guide: 'Guía de uso',
    documentation: 'Documentación', parametres_nav: 'Ajustes',
    compte_connecte: 'Cuenta conectada', notifications: 'Notificaciones',
    aucune_notification: 'Sin notificaciones', tout_effacer: 'Borrar todo',
    deconnexion: 'Cerrar sesión', deconnexion_confirm: '¿Seguro que quieres cerrar sesión?',
    se_deconnecter: 'Cerrar sesión', factures_nav: 'Facturas', cv_nav: 'CV',
    administration: 'Administración', utilisateurs: 'Usuarios',
    documents_nav: 'Documentos', statistiques: 'Estadísticas',
    acces_admin: 'Acceso Admin',
    gerer_users_docs: 'Gestiona usuarios, documentos y estadísticas globales',
    rechercher_utilisateur: 'Buscar usuario...', rechercher_document: 'Buscar documento o email...',
    utilisateur: 'Usuario', role: 'Rol', inscription: 'Registro',
    actions: 'Acciones', fichier: 'Archivo', type: 'Tipo',
    proprietaire: 'Propietario', date: 'Fecha',
    aucun_utilisateur: 'No se encontró usuario', aucun_document_admin: 'No se encontró documento',
    chargement: 'Cargando...', succes: 'Éxito', erreur: 'Error',
    attention: 'Atención', information: 'Información',
    deconnexion_titre: 'Cerrar sesión', changer_mdp: 'Cambiar contraseña',
    mdp_actuel: 'Contraseña actual', nouveau_mdp: 'Nueva contraseña',
    confirmer_mdp: 'Confirmar contraseña', activer_2fa: 'Activar 2FA',
    historique_connexion: 'Historial de conexiones', fermer: 'Cerrar',
    //CV
    cv_etape1: 'Mi CV', cv_etape2: 'Oferta & IA', cv_etape3: 'Vista previa & Exportar',
    cv_titre: 'CV Inteligente', cv_sous_titre: 'Crea tu CV optimizado ATS',
    cv_infos_perso: 'Información personal', cv_nom: 'Nombre completo', cv_poste: 'Puesto deseado',
    cv_tel: 'Teléfono', cv_ville: 'Ciudad', cv_pays: 'País', cv_linkedin: 'LinkedIn',
    cv_resume: 'Resumen profesional', cv_experiences: 'Experiencias',
    cv_ajouter_exp: 'Añadir experiencia', cv_formations: 'Formación',
    cv_ajouter_form: 'Añadir formación', cv_competences: 'Habilidades',
    cv_langues_cv: 'Idiomas', cv_template: 'Plantilla', cv_couleur: 'Color',
    cv_police: 'Fuente', cv_telecharger: 'Descargar PDF', cv_telecharger_word: 'Descargar Word',
    cv_suivant: 'Siguiente', cv_precedent: 'Anterior', cv_offre_emploi: 'Oferta de empleo',
    cv_analyser: 'Analizar & Adaptar', cv_analyse_ia: 'Análisis IA',
  },

  pt: {
    facturation: 'Faturação', clients: 'Clientes', crm: 'CRM', settings: 'Configurações',
    facture: 'Fatura', nouvelleFacture: 'Nova fatura',
    votre_entreprise: 'Sua empresa', nom_entreprise: 'Nome da empresa',
    infos_client: 'Informações do cliente', nom_client: 'Nome do cliente',
    adresse: 'Endereço', email: 'E-mail', telephone: 'Telefone',
    details_facture: 'Detalhes da fatura', numero_facture: 'Número da fatura',
    date_emission: 'Data de emissão', date_echeance: 'Data de vencimento',
    articles: 'Itens / Serviços', description: 'Descrição',
    quantite: 'Qtd.', prix_unit: 'Preço unit.', total: 'Total',
    ajouter_article: 'Adicionar item', tva: 'IVA (%)',
    notes: 'Notas / Condições de pagamento', sous_total: 'Subtotal',
    total_ttc: 'TOTAL', marquer_payee: 'Marcar como pago',
    marquer_impayee: 'Marcar como não pago', apercu: 'Pré-visualizar',
    telecharger_pdf: 'Baixar PDF', choisir_client: 'Escolher um cliente',
    devise: 'Moeda', rechercher_client: 'Pesquisar cliente...',
    tous: 'Todos', particuliers: 'Particulares', societes: 'Empresas',
    nouveau_client: 'Novo cliente', total_clients: 'Total de clientes',
    aucun_client: 'Nenhum cliente encontrado', ajouter_client: 'Adicionar cliente',
    modifier: 'Editar', supprimer: 'Excluir', annuler: 'Cancelar', enregistrer: 'Salvar',
    opportunites: 'Oportunidades', activites: 'Atividades', ajouter: 'Adicionar',
    nouvelle_opportunite: 'Nova oportunidade', intitule: 'Título',
    montant_ht: 'Valor (sem impostos)', mois_signature: 'Mês previsto de assinatura',
    statut: 'Status', destinataire: 'Destinatário', creer_opportunite: 'Criar oportunidade',
    tous_opp: 'Todos', remportees: 'Ganhas', perdues: 'Perdidas',
    aucune_activite: 'Nenhuma atividade ainda',
    parametres: 'Configurações', langue: 'Idioma',
    choisir_langue: 'Escolha o idioma do aplicativo',
    devise_defaut: 'Moeda padrão', choisir_devise: 'Moeda usada em todo o aplicativo',
    sauvegarder: 'Salvar',
    client_cree: 'Cliente criado com sucesso!', client_modifie: 'Cliente modificado com sucesso!',
    client_supprime: 'Cliente excluído!', opp_creee: 'Oportunidade criada com sucesso!',
    pdf_telecharge: 'PDF baixado!', parametres_sauvegardes: 'Configurações salvas!',
    erreur_chargement: 'Erro de carregamento', erreur_sauvegarde: 'Erro ao salvar',
    erreur_suppression: 'Erro ao excluir',
    dashboard: 'Painel', bienvenue: 'Bem-vindo', docs_par_jour: 'Documentos / Dia',
    creer_document: 'Criar documento', choisir_type: 'Escolha o tipo de documento',
    nouvelle_facture: 'Nova fatura', nouveau_cv: 'Novo CV',
    factures_creees: 'Faturas criadas', cvs_generes: 'CVs gerados',
    total_telechargements: 'Total de downloads', productivite: 'PRODUTIVIDADE',
    taux_utilisation: 'Taxa de utilização', docs_totaux: 'Total de documentos',
    tendance_mensuelle: 'Tendência mensal', actions_rapides: 'Ações rápidas',
    facture_pro: 'Crie uma fatura profissional', cv_ats: 'CV otimizado ATS',
    configurer_compte: 'Configure sua conta', guide: 'Guia de uso',
    documentation: 'Documentação', parametres_nav: 'Configurações',
    compte_connecte: 'Conta conectada', notifications: 'Notificações',
    aucune_notification: 'Sem notificações', tout_effacer: 'Limpar tudo',
    deconnexion: 'Sair', deconnexion_confirm: 'Tem certeza que deseja sair?',
    se_deconnecter: 'Sair', factures_nav: 'Faturas', cv_nav: 'CV',
    administration: 'Administração', utilisateurs: 'Usuários',
    documents_nav: 'Documentos', statistiques: 'Estatísticas',
    acces_admin: 'Acesso Admin',
    gerer_users_docs: 'Gerencie usuários, documentos e estatísticas globais',
    rechercher_utilisateur: 'Pesquisar usuário...', rechercher_document: 'Pesquisar documento ou email...',
    utilisateur: 'Usuário', role: 'Função', inscription: 'Cadastro',
    actions: 'Ações', fichier: 'Arquivo', type: 'Tipo',
    proprietaire: 'Proprietário', date: 'Data',
    aucun_utilisateur: 'Nenhum usuário encontrado', aucun_document_admin: 'Nenhum documento encontrado',
    chargement: 'Carregando...', succes: 'Sucesso', erreur: 'Erro',
    attention: 'Atenção', information: 'Informação',
    deconnexion_titre: 'Sair', changer_mdp: 'Alterar senha',
    mdp_actuel: 'Senha atual', nouveau_mdp: 'Nova senha',
    confirmer_mdp: 'Confirmar senha', activer_2fa: 'Ativar 2FA',
    historique_connexion: 'Histórico de login', fermer: 'Fechar',
    //CV
    cv_etape1: 'Meu CV', cv_etape2: 'Oferta & IA', cv_etape3: 'Pré-visualizar & Exportar',
    cv_titre: 'CV Inteligente', cv_sous_titre: 'Crie seu CV otimizado para ATS',
    cv_infos_perso: 'Informações pessoais', cv_nom: 'Nome completo', cv_poste: 'Cargo pretendido',
    cv_tel: 'Telefone', cv_ville: 'Cidade', cv_pays: 'País', cv_linkedin: 'LinkedIn',
    cv_resume: 'Resumo profissional', cv_experiences: 'Experiências',
    cv_ajouter_exp: 'Adicionar experiência', cv_formations: 'Formação',
    cv_ajouter_form: 'Adicionar formação', cv_competences: 'Competências',
    cv_langues_cv: 'Idiomas', cv_template: 'Modelo', cv_couleur: 'Cor',
    cv_police: 'Fonte', cv_telecharger: 'Baixar PDF', cv_telecharger_word: 'Baixar Word',
    cv_suivant: 'Próximo', cv_precedent: 'Anterior', cv_offre_emploi: 'Oferta de emprego',
    cv_analyser: 'Analisar & Adaptar', cv_analyse_ia: 'Análise IA',
  },

  de: {
    facturation: 'Abrechnung', clients: 'Kunden', crm: 'CRM', settings: 'Einstellungen',
    facture: 'Rechnung', nouvelleFacture: 'Neue Rechnung',
    votre_entreprise: 'Ihr Unternehmen', nom_entreprise: 'Firmenname',
    infos_client: 'Kundeninformationen', nom_client: 'Kundenname',
    adresse: 'Adresse', email: 'E-Mail', telephone: 'Telefon',
    details_facture: 'Rechnungsdetails', numero_facture: 'Rechnungsnummer',
    date_emission: 'Ausstellungsdatum', date_echeance: 'Fälligkeitsdatum',
    articles: 'Artikel / Dienstleistungen', description: 'Beschreibung',
    quantite: 'Menge', prix_unit: 'Einzelpreis', total: 'Gesamt',
    ajouter_article: 'Artikel hinzufügen', tva: 'MwSt. (%)',
    notes: 'Notizen / Zahlungsbedingungen', sous_total: 'Zwischensumme',
    total_ttc: 'GESAMT', marquer_payee: 'Als bezahlt markieren',
    marquer_impayee: 'Als unbezahlt markieren', apercu: 'Vorschau',
    telecharger_pdf: 'PDF herunterladen', choisir_client: 'Kunden auswählen',
    devise: 'Währung', rechercher_client: 'Kunde suchen...',
    tous: 'Alle', particuliers: 'Privatpersonen', societes: 'Unternehmen',
    nouveau_client: 'Neuer Kunde', total_clients: 'Kunden gesamt',
    aucun_client: 'Kein Kunde gefunden', ajouter_client: 'Kunden hinzufügen',
    modifier: 'Bearbeiten', supprimer: 'Löschen', annuler: 'Abbrechen', enregistrer: 'Speichern',
    opportunites: 'Chancen', activites: 'Aktivitäten', ajouter: 'Hinzufügen',
    nouvelle_opportunite: 'Neue Chance', intitule: 'Titel',
    montant_ht: 'Betrag (netto)', mois_signature: 'Erwarteter Unterzeichnungsmonat',
    statut: 'Status', destinataire: 'Empfänger', creer_opportunite: 'Chance erstellen',
    tous_opp: 'Alle', remportees: 'Gewonnen', perdues: 'Verloren',
    aucune_activite: 'Noch keine Aktivitäten',
    parametres: 'Einstellungen', langue: 'Sprache',
    choisir_langue: 'Anwendungssprache wählen',
    devise_defaut: 'Standardwährung', choisir_devise: 'In der gesamten App verwendete Währung',
    sauvegarder: 'Speichern',
    client_cree: 'Kunde erfolgreich erstellt!', client_modifie: 'Kunde erfolgreich geändert!',
    client_supprime: 'Kunde gelöscht!', opp_creee: 'Chance erfolgreich erstellt!',
    pdf_telecharge: 'PDF heruntergeladen!', parametres_sauvegardes: 'Einstellungen gespeichert!',
    erreur_chargement: 'Ladefehler', erreur_sauvegarde: 'Speicherfehler',
    erreur_suppression: 'Löschfehler',
    dashboard: 'Dashboard', bienvenue: 'Willkommen', docs_par_jour: 'Dokumente / Tag',
    creer_document: 'Dokument erstellen', choisir_type: 'Wählen Sie den Dokumenttyp',
    nouvelle_facture: 'Neue Rechnung', nouveau_cv: 'Neuer Lebenslauf',
    factures_creees: 'Rechnungen erstellt', cvs_generes: 'Lebensläufe generiert',
    total_telechargements: 'Gesamtdownloads', productivite: 'PRODUKTIVITÄT',
    taux_utilisation: 'Nutzungsrate', docs_totaux: 'Dokumente gesamt',
    tendance_mensuelle: 'Monatlicher Trend', actions_rapides: 'Schnellaktionen',
    facture_pro: 'Professionelle Rechnung erstellen', cv_ats: 'ATS-optimierter Lebenslauf',
    configurer_compte: 'Konto konfigurieren', guide: 'Benutzerhandbuch',
    documentation: 'Dokumentation', parametres_nav: 'Einstellungen',
    compte_connecte: 'Verbundenes Konto', notifications: 'Benachrichtigungen',
    aucune_notification: 'Keine Benachrichtigungen', tout_effacer: 'Alle löschen',
    deconnexion: 'Abmelden', deconnexion_confirm: 'Möchten Sie sich wirklich abmelden?',
    se_deconnecter: 'Abmelden', factures_nav: 'Rechnungen', cv_nav: 'Lebenslauf',
    administration: 'Administration', utilisateurs: 'Benutzer',
    documents_nav: 'Dokumente', statistiques: 'Statistiken',
    acces_admin: 'Admin-Zugang',
    gerer_users_docs: 'Benutzer, Dokumente und globale Statistiken verwalten',
    rechercher_utilisateur: 'Benutzer suchen...', rechercher_document: 'Dokument oder E-Mail suchen...',
    utilisateur: 'Benutzer', role: 'Rolle', inscription: 'Registrierung',
    actions: 'Aktionen', fichier: 'Datei', type: 'Typ',
    proprietaire: 'Eigentümer', date: 'Datum',
    aucun_utilisateur: 'Kein Benutzer gefunden', aucun_document_admin: 'Kein Dokument gefunden',
    chargement: 'Laden...', succes: 'Erfolg', erreur: 'Fehler',
    attention: 'Achtung', information: 'Information',
    deconnexion_titre: 'Abmelden', changer_mdp: 'Passwort ändern',
    mdp_actuel: 'Aktuelles Passwort', nouveau_mdp: 'Neues Passwort',
    confirmer_mdp: 'Passwort bestätigen', activer_2fa: '2FA aktivieren',
    historique_connexion: 'Anmeldeverlauf', fermer: 'Schließen',
    cv_etape1: 'Mein Lebenslauf', cv_etape2: 'Stellenangebot & KI', cv_etape3: 'Vorschau & Export',
    cv_titre: 'Intelligenter Lebenslauf', cv_sous_titre: 'Erstellen Sie Ihren ATS-optimierten Lebenslauf',
    cv_infos_perso: 'Persönliche Informationen', cv_nom: 'Vollständiger Name', cv_poste: 'Angestrebte Stelle',
    cv_tel: 'Telefon', cv_ville: 'Stadt', cv_pays: 'Land', cv_linkedin: 'LinkedIn',
    cv_resume: 'Berufliche Zusammenfassung', cv_experiences: 'Erfahrungen',
    cv_ajouter_exp: 'Erfahrung hinzufügen', cv_formations: 'Ausbildung',
    cv_ajouter_form: 'Ausbildung hinzufügen', cv_competences: 'Fähigkeiten',
    cv_langues_cv: 'Sprachen', cv_template: 'Vorlage', cv_couleur: 'Farbe',
    cv_police: 'Schriftart', cv_telecharger: 'PDF herunterladen', cv_telecharger_word: 'Word herunterladen',
    cv_suivant: 'Weiter', cv_precedent: 'Zurück', cv_offre_emploi: 'Stellenangebot',
    cv_analyser: 'Analysieren & Anpassen', cv_analyse_ia: 'KI-Analyse',
  },

  it: {
    facturation: 'Fatturazione', clients: 'Clienti', crm: 'CRM', settings: 'Impostazioni',
    facture: 'Fattura', nouvelleFacture: 'Nuova fattura',
    votre_entreprise: 'La tua azienda', nom_entreprise: "Nome dell'azienda",
    infos_client: 'Informazioni cliente', nom_client: 'Nome del cliente',
    adresse: 'Indirizzo', email: 'Email', telephone: 'Telefono',
    details_facture: 'Dettagli fattura', numero_facture: 'Numero fattura',
    date_emission: 'Data di emissione', date_echeance: 'Data di scadenza',
    articles: 'Articoli / Servizi', description: 'Descrizione',
    quantite: 'Qtà', prix_unit: 'Prezzo unit.', total: 'Totale',
    ajouter_article: 'Aggiungi articolo', tva: 'IVA (%)',
    notes: 'Note / Condizioni di pagamento', sous_total: 'Subtotale',
    total_ttc: 'TOTALE', marquer_payee: 'Segna come pagata',
    marquer_impayee: 'Segna come non pagata', apercu: 'Anteprima',
    telecharger_pdf: 'Scarica PDF', choisir_client: 'Scegli un cliente',
    devise: 'Valuta', rechercher_client: 'Cerca cliente...',
    tous: 'Tutti', particuliers: 'Privati', societes: 'Aziende',
    nouveau_client: 'Nuovo cliente', total_clients: 'Totale clienti',
    aucun_client: 'Nessun cliente trovato', ajouter_client: 'Aggiungi cliente',
    modifier: 'Modifica', supprimer: 'Elimina', annuler: 'Annulla', enregistrer: 'Salva',
    opportunites: 'Opportunità', activites: 'Attività', ajouter: 'Aggiungi',
    nouvelle_opportunite: 'Nuova opportunità', intitule: 'Titolo',
    montant_ht: 'Importo (al netto)', mois_signature: 'Mese di firma previsto',
    statut: 'Stato', destinataire: 'Destinatario', creer_opportunite: 'Crea opportunità',
    tous_opp: 'Tutti', remportees: 'Vinte', perdues: 'Perse',
    aucune_activite: 'Nessuna attività ancora',
    parametres: 'Impostazioni', langue: 'Lingua',
    choisir_langue: "Scegli la lingua dell'applicazione",
    devise_defaut: 'Valuta predefinita',
    choisir_devise: "Valuta utilizzata in tutta l'applicazione",
    sauvegarder: 'Salva',
    client_cree: 'Cliente creato con successo!', client_modifie: 'Cliente modificato con successo!',
    client_supprime: 'Cliente eliminato!', opp_creee: 'Opportunità creata con successo!',
    pdf_telecharge: 'PDF scaricato!', parametres_sauvegardes: 'Impostazioni salvate!',
    erreur_chargement: 'Errore di caricamento', erreur_sauvegarde: 'Errore di salvataggio',
    erreur_suppression: 'Errore di eliminazione',
    dashboard: 'Dashboard', bienvenue: 'Benvenuto', docs_par_jour: 'Documenti / Giorno',
    creer_document: 'Crea documento', choisir_type: 'Scegli il tipo di documento',
    nouvelle_facture: 'Nuova fattura', nouveau_cv: 'Nuovo CV',
    factures_creees: 'Fatture create', cvs_generes: 'CV generati',
    total_telechargements: 'Download totali', productivite: 'PRODUTTIVITÀ',
    taux_utilisation: 'Tasso di utilizzo', docs_totaux: 'Documenti totali',
    tendance_mensuelle: 'Tendenza mensile', actions_rapides: 'Azioni rapide',
    facture_pro: 'Crea una fattura professionale', cv_ats: 'CV ottimizzato ATS',
    configurer_compte: 'Configura il tuo account', guide: 'Guida utente',
    documentation: 'Documentazione', parametres_nav: 'Impostazioni',
    compte_connecte: 'Account connesso', notifications: 'Notifiche',
    aucune_notification: 'Nessuna notifica', tout_effacer: 'Cancella tutto',
    deconnexion: 'Disconnetti', deconnexion_confirm: 'Sei sicuro di voler uscire?',
    se_deconnecter: 'Disconnetti', factures_nav: 'Fatture', cv_nav: 'CV',
    administration: 'Amministrazione', utilisateurs: 'Utenti',
    documents_nav: 'Documenti', statistiques: 'Statistiche',
    acces_admin: 'Accesso Admin',
    gerer_users_docs: 'Gestisci utenti, documenti e statistiche globali',
    rechercher_utilisateur: 'Cerca utente...', rechercher_document: 'Cerca documento o email...',
    utilisateur: 'Utente', role: 'Ruolo', inscription: 'Registrazione',
    actions: 'Azioni', fichier: 'File', type: 'Tipo',
    proprietaire: 'Proprietario', date: 'Data',
    aucun_utilisateur: 'Nessun utente trovato', aucun_document_admin: 'Nessun documento trovato',
    chargement: 'Caricamento...', succes: 'Successo', erreur: 'Errore',
    attention: 'Attenzione', information: 'Informazione',
    deconnexion_titre: 'Disconnetti', changer_mdp: 'Cambia password',
    mdp_actuel: 'Password attuale', nouveau_mdp: 'Nuova password',
    confirmer_mdp: 'Conferma password', activer_2fa: 'Attiva 2FA',
    historique_connexion: 'Cronologia accessi', fermer: 'Chiudi',
    cv_etape1: 'Il mio CV', cv_etape2: 'Offerta & IA', cv_etape3: 'Anteprima & Esporta',
    cv_titre: 'CV Intelligente', cv_sous_titre: 'Crea il tuo CV ottimizzato ATS',
    cv_infos_perso: 'Informazioni personali', cv_nom: 'Nome completo', cv_poste: 'Posizione desiderata',
    cv_tel: 'Telefono', cv_ville: 'Città', cv_pays: 'Paese', cv_linkedin: 'LinkedIn',
    cv_resume: 'Riepilogo professionale', cv_experiences: 'Esperienze',
    cv_ajouter_exp: 'Aggiungi esperienza', cv_formations: 'Formazione',
    cv_ajouter_form: 'Aggiungi formazione', cv_competences: 'Competenze',
    cv_langues_cv: 'Lingue', cv_template: 'Template', cv_couleur: 'Colore',
    cv_police: 'Carattere', cv_telecharger: 'Scarica PDF', cv_telecharger_word: 'Scarica Word',
    cv_suivant: 'Avanti', cv_precedent: 'Indietro', cv_offre_emploi: 'Offerta di lavoro',
    cv_analyser: 'Analizza & Adatta', cv_analyse_ia: 'Analisi IA',
  },

  ar: {
    facturation: 'الفوترة', clients: 'العملاء', crm: 'إدارة العملاء', settings: 'الإعدادات',
    facture: 'فاتورة', nouvelleFacture: 'فاتورة جديدة',
    votre_entreprise: 'شركتك', nom_entreprise: 'اسم الشركة',
    infos_client: 'معلومات العميل', nom_client: 'اسم العميل',
    adresse: 'العنوان', email: 'البريد الإلكتروني', telephone: 'الهاتف',
    details_facture: 'تفاصيل الفاتورة', numero_facture: 'رقم الفاتورة',
    date_emission: 'تاريخ الإصدار', date_echeance: 'تاريخ الاستحقاق',
    articles: 'العناصر / الخدمات', description: 'الوصف',
    quantite: 'الكمية', prix_unit: 'سعر الوحدة', total: 'المجموع',
    ajouter_article: 'إضافة عنصر', tva: 'ضريبة القيمة المضافة (%)',
    notes: 'ملاحظات / شروط الدفع', sous_total: 'المجموع الفرعي',
    total_ttc: 'المجموع الكلي', marquer_payee: 'تحديد كمدفوعة',
    marquer_impayee: 'تحديد كغير مدفوعة', apercu: 'معاينة',
    telecharger_pdf: 'تنزيل PDF', choisir_client: 'اختيار عميل',
    devise: 'العملة', rechercher_client: 'البحث عن عميل...',
    tous: 'الكل', particuliers: 'أفراد', societes: 'شركات',
    nouveau_client: 'عميل جديد', total_clients: 'إجمالي العملاء',
    aucun_client: 'لم يتم العثور على عميل', ajouter_client: 'إضافة عميل',
    modifier: 'تعديل', supprimer: 'حذف', annuler: 'إلغاء', enregistrer: 'حفظ',
    opportunites: 'الفرص', activites: 'الأنشطة', ajouter: 'إضافة',
    nouvelle_opportunite: 'فرصة جديدة', intitule: 'العنوان',
    montant_ht: 'المبلغ (بدون ضريبة)', mois_signature: 'شهر التوقيع المتوقع',
    statut: 'الحالة', destinataire: 'المستلم', creer_opportunite: 'إنشاء فرصة',
    tous_opp: 'الكل', remportees: 'مكتسبة', perdues: 'مفقودة',
    aucune_activite: 'لا توجد أنشطة بعد',
    parametres: 'الإعدادات', langue: 'اللغة',
    choisir_langue: 'اختر لغة التطبيق',
    devise_defaut: 'العملة الافتراضية',
    choisir_devise: 'العملة المستخدمة في جميع أنحاء التطبيق',
    sauvegarder: 'حفظ',
    client_cree: 'تم إنشاء العميل بنجاح!', client_modifie: 'تم تعديل العميل بنجاح!',
    client_supprime: 'تم حذف العميل!', opp_creee: 'تم إنشاء الفرصة بنجاح!',
    pdf_telecharge: 'تم تنزيل PDF!', parametres_sauvegardes: 'تم حفظ الإعدادات!',
    erreur_chargement: 'خطأ في التحميل', erreur_sauvegarde: 'خطأ في الحفظ',
    erreur_suppression: 'خطأ في الحذف',
    dashboard: 'لوحة التحكم', bienvenue: 'مرحباً', docs_par_jour: 'مستندات / يوم',
    creer_document: 'إنشاء مستند', choisir_type: 'اختر نوع المستند',
    nouvelle_facture: 'فاتورة جديدة', nouveau_cv: 'سيرة ذاتية جديدة',
    factures_creees: 'الفواتير المنشأة', cvs_generes: 'السير الذاتية المنشأة',
    total_telechargements: 'إجمالي التنزيلات', productivite: 'الإنتاجية',
    taux_utilisation: 'معدل الاستخدام', docs_totaux: 'إجمالي المستندات',
    tendance_mensuelle: 'الاتجاه الشهري', actions_rapides: 'إجراءات سريعة',
    facture_pro: 'أنشئ فاتورة احترافية', cv_ats: 'سيرة ذاتية محسّنة لـ ATS',
    configurer_compte: 'تهيئة حسابك', guide: 'دليل الاستخدام',
    documentation: 'التوثيق', parametres_nav: 'الإعدادات',
    compte_connecte: 'الحساب متصل', notifications: 'الإشعارات',
    aucune_notification: 'لا توجد إشعارات', tout_effacer: 'مسح الكل',
    deconnexion: 'تسجيل الخروج', deconnexion_confirm: 'هل أنت متأكد من تسجيل الخروج؟',
    se_deconnecter: 'تسجيل الخروج', factures_nav: 'الفواتير', cv_nav: 'السيرة الذاتية',
    administration: 'الإدارة', utilisateurs: 'المستخدمون',
    documents_nav: 'المستندات', statistiques: 'الإحصائيات',
    acces_admin: 'وصول المسؤول',
    gerer_users_docs: 'إدارة المستخدمين والمستندات والإحصائيات العامة',
    rechercher_utilisateur: 'البحث عن مستخدم...', rechercher_document: 'البحث عن مستند أو بريد إلكتروني...',
    utilisateur: 'مستخدم', role: 'الدور', inscription: 'التسجيل',
    actions: 'الإجراءات', fichier: 'ملف', type: 'النوع',
    proprietaire: 'المالك', date: 'التاريخ',
    aucun_utilisateur: 'لم يتم العثور على مستخدم', aucun_document_admin: 'لم يتم العثور على مستند',
    chargement: 'جارٍ التحميل...', succes: 'نجاح', erreur: 'خطأ',
    attention: 'تنبيه', information: 'معلومة',
    deconnexion_titre: 'تسجيل الخروج', changer_mdp: 'تغيير كلمة المرور',
    mdp_actuel: 'كلمة المرور الحالية', nouveau_mdp: 'كلمة مرور جديدة',
    confirmer_mdp: 'تأكيد كلمة المرور', activer_2fa: 'تفعيل المصادقة الثنائية',
    historique_connexion: 'سجل تسجيل الدخول', fermer: 'إغلاق',
    cv_etape1: 'سيرتي الذاتية', cv_etape2: 'عرض العمل والذكاء الاصطناعي', cv_etape3: 'معاينة وتصدير',
    cv_titre: 'السيرة الذاتية الذكية', cv_sous_titre: 'أنشئ سيرتك الذاتية المحسّنة لـ ATS',
    cv_infos_perso: 'المعلومات الشخصية', cv_nom: 'الاسم الكامل', cv_poste: 'المنصب المطلوب',
    cv_tel: 'الهاتف', cv_ville: 'المدينة', cv_pays: 'البلد', cv_linkedin: 'LinkedIn',
    cv_resume: 'الملخص المهني', cv_experiences: 'الخبرات',
    cv_ajouter_exp: 'إضافة خبرة', cv_formations: 'التعليم',
    cv_ajouter_form: 'إضافة تعليم', cv_competences: 'المهارات',
    cv_langues_cv: 'اللغات', cv_template: 'القالب', cv_couleur: 'اللون',
    cv_police: 'الخط', cv_telecharger: 'تنزيل PDF', cv_telecharger_word: 'تنزيل Word',
    cv_suivant: 'التالي', cv_precedent: 'السابق', cv_offre_emploi: 'عرض العمل',
    cv_analyser: 'تحليل وتكييف', cv_analyse_ia: 'تحليل الذكاء الاصطناعي',
  },

  zh: {
    facturation: '账单', clients: '客户', crm: '客户管理', settings: '设置',
    facture: '发票', nouvelleFacture: '新发票',
    votre_entreprise: '您的公司', nom_entreprise: '公司名称',
    infos_client: '客户信息', nom_client: '客户姓名',
    adresse: '地址', email: '电子邮件', telephone: '电话',
    details_facture: '发票详情', numero_facture: '发票编号',
    date_emission: '开具日期', date_echeance: '到期日期',
    articles: '商品 / 服务', description: '描述',
    quantite: '数量', prix_unit: '单价', total: '合计',
    ajouter_article: '添加商品', tva: '增值税 (%)',
    notes: '备注 / 付款条款', sous_total: '小计',
    total_ttc: '总计', marquer_payee: '标记为已付', marquer_impayee: '标记为未付',
    apercu: '预览', telecharger_pdf: '下载PDF', choisir_client: '选择客户',
    devise: '货币', rechercher_client: '搜索客户...',
    tous: '全部', particuliers: '个人', societes: '公司',
    nouveau_client: '新客户', total_clients: '客户总数',
    aucun_client: '未找到客户', ajouter_client: '添加客户',
    modifier: '编辑', supprimer: '删除', annuler: '取消', enregistrer: '保存',
    opportunites: '商机', activites: '活动', ajouter: '添加',
    nouvelle_opportunite: '新商机', intitule: '标题',
    montant_ht: '金额（含税前）', mois_signature: '预计签署月份',
    statut: '状态', destinataire: '收件人', creer_opportunite: '创建商机',
    tous_opp: '全部', remportees: '已赢得', perdues: '已失去',
    aucune_activite: '暂无活动',
    parametres: '设置', langue: '语言', choisir_langue: '选择应用语言',
    devise_defaut: '默认货币', choisir_devise: '整个应用中使用的货币',
    sauvegarder: '保存',
    client_cree: '客户创建成功！', client_modifie: '客户修改成功！',
    client_supprime: '客户已删除！', opp_creee: '商机创建成功！',
    pdf_telecharge: 'PDF已下载！', parametres_sauvegardes: '设置已保存！',
    erreur_chargement: '加载错误', erreur_sauvegarde: '保存错误', erreur_suppression: '删除错误',
    dashboard: '仪表板', bienvenue: '欢迎', docs_par_jour: '文件 / 天',
    creer_document: '创建文件', choisir_type: '选择文件类型',
    nouvelle_facture: '新发票', nouveau_cv: '新简历',
    factures_creees: '已创建发票', cvs_generes: '已生成简历',
    total_telechargements: '总下载量', productivite: '生产力',
    taux_utilisation: '使用率', docs_totaux: '文件总数',
    tendance_mensuelle: '月度趋势', actions_rapides: '快速操作',
    facture_pro: '创建专业发票', cv_ats: 'ATS优化简历',
    configurer_compte: '配置您的账户', guide: '使用指南',
    documentation: '文档', parametres_nav: '设置',
    compte_connecte: '账户已连接', notifications: '通知',
    aucune_notification: '没有通知', tout_effacer: '全部清除',
    deconnexion: '退出登录', deconnexion_confirm: '您确定要退出吗？',
    se_deconnecter: '退出', factures_nav: '发票', cv_nav: '简历',
    administration: '管理', utilisateurs: '用户',
    documents_nav: '文件', statistiques: '统计',
    acces_admin: '管理员访问',
    gerer_users_docs: '管理用户、文件和全局统计',
    rechercher_utilisateur: '搜索用户...', rechercher_document: '搜索文件或邮箱...',
    utilisateur: '用户', role: '角色', inscription: '注册日期',
    actions: '操作', fichier: '文件', type: '类型',
    proprietaire: '所有者', date: '日期',
    aucun_utilisateur: '未找到用户', aucun_document_admin: '未找到文件',
    chargement: '加载中...', succes: '成功', erreur: '错误',
    attention: '警告', information: '信息',
    deconnexion_titre: '退出登录', changer_mdp: '修改密码',
    mdp_actuel: '当前密码', nouveau_mdp: '新密码',
    confirmer_mdp: '确认密码', activer_2fa: '启用双重认证',
    historique_connexion: '登录历史', fermer: '关闭',
    cv_etape1: '我的简历', cv_etape2: '职位与AI', cv_etape3: '预览与导出',
    cv_titre: '智能简历', cv_sous_titre: '创建您的ATS优化简历',
    cv_infos_perso: '个人信息', cv_nom: '全名', cv_poste: '目标职位',
    cv_tel: '电话', cv_ville: '城市', cv_pays: '国家', cv_linkedin: 'LinkedIn',
    cv_resume: '职业摘要', cv_experiences: '工作经历',
    cv_ajouter_exp: '添加经历', cv_formations: '教育背景',
    cv_ajouter_form: '添加教育', cv_competences: '技能',
    cv_langues_cv: '语言', cv_template: '模板', cv_couleur: '颜色',
    cv_police: '字体', cv_telecharger: '下载PDF', cv_telecharger_word: '下载Word',
    cv_suivant: '下一步', cv_precedent: '上一步', cv_offre_emploi: '职位描述',
    cv_analyser: '分析与适配', cv_analyse_ia: 'AI分析',
  },

  ja: {
    facturation: '請求', clients: 'クライアント', crm: 'CRM', settings: '設定',
    facture: '請求書', nouvelleFacture: '新しい請求書',
    votre_entreprise: '会社情報', nom_entreprise: '会社名',
    infos_client: 'クライアント情報', nom_client: 'クライアント名',
    adresse: '住所', email: 'メール', telephone: '電話',
    details_facture: '請求書詳細', numero_facture: '請求書番号',
    date_emission: '発行日', date_echeance: '支払期限',
    articles: '商品・サービス', description: '説明',
    quantite: '数量', prix_unit: '単価', total: '合計',
    ajouter_article: '商品を追加', tva: '消費税 (%)',
    notes: 'メモ・支払条件', sous_total: '小計',
    total_ttc: '合計', marquer_payee: '支払済みにする', marquer_impayee: '未払いにする',
    apercu: 'プレビュー', telecharger_pdf: 'PDFダウンロード', choisir_client: 'クライアントを選択',
    devise: '通貨', rechercher_client: 'クライアントを検索...',
    tous: 'すべて', particuliers: '個人', societes: '法人',
    nouveau_client: '新規クライアント', total_clients: '総クライアント数',
    aucun_client: 'クライアントが見つかりません', ajouter_client: 'クライアントを追加',
    modifier: '編集', supprimer: '削除', annuler: 'キャンセル', enregistrer: '保存',
    opportunites: '商談', activites: '活動', ajouter: '追加',
    nouvelle_opportunite: '新規商談', intitule: 'タイトル',
    montant_ht: '金額（税抜）', mois_signature: '予定署名月',
    statut: 'ステータス', destinataire: '宛先', creer_opportunite: '商談を作成',
    tous_opp: 'すべて', remportees: '成約', perdues: '失注',
    aucune_activite: 'まだ活動がありません',
    parametres: '設定', langue: '言語', choisir_langue: 'アプリの言語を選択',
    devise_defaut: 'デフォルト通貨', choisir_devise: 'アプリ全体で使用する通貨',
    sauvegarder: '保存',
    client_cree: 'クライアントを作成しました！', client_modifie: 'クライアントを更新しました！',
    client_supprime: 'クライアントを削除しました！', opp_creee: '商談を作成しました！',
    pdf_telecharge: 'PDFをダウンロードしました！', parametres_sauvegardes: '設定を保存しました！',
    erreur_chargement: '読み込みエラー', erreur_sauvegarde: '保存エラー', erreur_suppression: '削除エラー',
    dashboard: 'ダッシュボード', bienvenue: 'ようこそ', docs_par_jour: '文書 / 日',
    creer_document: '文書を作成', choisir_type: '文書の種類を選択',
    nouvelle_facture: '新しい請求書', nouveau_cv: '新しい履歴書',
    factures_creees: '作成した請求書', cvs_generes: '作成した履歴書',
    total_telechargements: '総ダウンロード数', productivite: '生産性',
    taux_utilisation: '利用率', docs_totaux: '総文書数',
    tendance_mensuelle: '月次トレンド', actions_rapides: 'クイックアクション',
    facture_pro: 'プロの請求書を作成', cv_ats: 'ATS最適化履歴書',
    configurer_compte: 'アカウントを設定', guide: 'ユーザーガイド',
    documentation: 'ドキュメント', parametres_nav: '設定',
    compte_connecte: 'アカウント接続済み', notifications: '通知',
    aucune_notification: '通知なし', tout_effacer: 'すべて削除',
    deconnexion: 'ログアウト', deconnexion_confirm: 'ログアウトしますか？',
    se_deconnecter: 'ログアウト', factures_nav: '請求書', cv_nav: '履歴書',
    administration: '管理', utilisateurs: 'ユーザー',
    documents_nav: '文書', statistiques: '統計',
    acces_admin: '管理者アクセス',
    gerer_users_docs: 'ユーザー、文書、グローバル統計を管理',
    rechercher_utilisateur: 'ユーザーを検索...', rechercher_document: '文書またはメールを検索...',
    utilisateur: 'ユーザー', role: '役割', inscription: '登録日',
    actions: 'アクション', fichier: 'ファイル', type: 'タイプ',
    proprietaire: '所有者', date: '日付',
    aucun_utilisateur: 'ユーザーが見つかりません', aucun_document_admin: '文書が見つかりません',
    chargement: '読み込み中...', succes: '成功', erreur: 'エラー',
    attention: '警告', information: '情報',
    deconnexion_titre: 'ログアウト', changer_mdp: 'パスワード変更',
    mdp_actuel: '現在のパスワード', nouveau_mdp: '新しいパスワード',
    confirmer_mdp: 'パスワードを確認', activer_2fa: '2FA を有効にする',
    historique_connexion: 'ログイン履歴', fermer: '閉じる',
    cv_etape1: '私の履歴書', cv_etape2: '求人票とAI', cv_etape3: 'プレビューとエクスポート',
    cv_titre: 'スマート履歴書', cv_sous_titre: 'ATS最適化履歴書を作成',
    cv_infos_perso: '個人情報', cv_nom: '氏名', cv_poste: '希望職種',
    cv_tel: '電話', cv_ville: '市区町村', cv_pays: '国', cv_linkedin: 'LinkedIn',
    cv_resume: '職務要約', cv_experiences: '職歴',
    cv_ajouter_exp: '職歴を追加', cv_formations: '学歴',
    cv_ajouter_form: '学歴を追加', cv_competences: 'スキル',
    cv_langues_cv: '言語', cv_template: 'テンプレート', cv_couleur: '色',
    cv_police: 'フォント', cv_telecharger: 'PDFダウンロード', cv_telecharger_word: 'Wordダウンロード',
    cv_suivant: '次へ', cv_precedent: '前へ', cv_offre_emploi: '求人票',
    cv_analyser: '分析・適応', cv_analyse_ia: 'AI分析',
  },

  ru: {
    facturation: 'Выставление счетов', clients: 'Клиенты', crm: 'CRM', settings: 'Настройки',
    facture: 'Счёт', nouvelleFacture: 'Новый счёт',
    votre_entreprise: 'Ваша компания', nom_entreprise: 'Название компании',
    infos_client: 'Информация о клиенте', nom_client: 'Имя клиента',
    adresse: 'Адрес', email: 'Эл. почта', telephone: 'Телефон',
    details_facture: 'Детали счёта', numero_facture: 'Номер счёта',
    date_emission: 'Дата выставления', date_echeance: 'Срок оплаты',
    articles: 'Товары / Услуги', description: 'Описание',
    quantite: 'Кол-во', prix_unit: 'Цена за ед.', total: 'Итого',
    ajouter_article: 'Добавить позицию', tva: 'НДС (%)',
    notes: 'Заметки / Условия оплаты', sous_total: 'Подытог',
    total_ttc: 'ИТОГО', marquer_payee: 'Отметить как оплаченный',
    marquer_impayee: 'Отметить как неоплаченный', apercu: 'Предпросмотр',
    telecharger_pdf: 'Скачать PDF', choisir_client: 'Выбрать клиента',
    devise: 'Валюта', rechercher_client: 'Поиск клиента...',
    tous: 'Все', particuliers: 'Физические лица', societes: 'Компании',
    nouveau_client: 'Новый клиент', total_clients: 'Всего клиентов',
    aucun_client: 'Клиент не найден', ajouter_client: 'Добавить клиента',
    modifier: 'Изменить', supprimer: 'Удалить', annuler: 'Отмена', enregistrer: 'Сохранить',
    opportunites: 'Возможности', activites: 'Активности', ajouter: 'Добавить',
    nouvelle_opportunite: 'Новая возможность', intitule: 'Название',
    montant_ht: 'Сумма (без налога)', mois_signature: 'Ожидаемый месяц подписания',
    statut: 'Статус', destinataire: 'Получатель', creer_opportunite: 'Создать возможность',
    tous_opp: 'Все', remportees: 'Выиграно', perdues: 'Проиграно',
    aucune_activite: 'Активностей пока нет',
    parametres: 'Настройки', langue: 'Язык', choisir_langue: 'Выберите язык приложения',
    devise_defaut: 'Валюта по умолчанию', choisir_devise: 'Валюта, используемая во всём приложении',
    sauvegarder: 'Сохранить',
    client_cree: 'Клиент успешно создан!', client_modifie: 'Клиент успешно изменён!',
    client_supprime: 'Клиент удалён!', opp_creee: 'Возможность успешно создана!',
    pdf_telecharge: 'PDF скачан!', parametres_sauvegardes: 'Настройки сохранены!',
    erreur_chargement: 'Ошибка загрузки', erreur_sauvegarde: 'Ошибка сохранения',
    erreur_suppression: 'Ошибка удаления',
    dashboard: 'Панель управления', bienvenue: 'Добро пожаловать', docs_par_jour: 'Документов / День',
    creer_document: 'Создать документ', choisir_type: 'Выберите тип документа',
    nouvelle_facture: 'Новый счёт', nouveau_cv: 'Новое резюме',
    factures_creees: 'Создано счетов', cvs_generes: 'Создано резюме',
    total_telechargements: 'Всего загрузок', productivite: 'ПРОИЗВОДИТЕЛЬНОСТЬ',
    taux_utilisation: 'Уровень использования', docs_totaux: 'Всего документов',
    tendance_mensuelle: 'Месячная тенденция', actions_rapides: 'Быстрые действия',
    facture_pro: 'Создайте профессиональный счёт', cv_ats: 'Резюме, оптимизированное для ATS',
    configurer_compte: 'Настройте ваш аккаунт', guide: 'Руководство пользователя',
    documentation: 'Документация', parametres_nav: 'Настройки',
    compte_connecte: 'Аккаунт подключён', notifications: 'Уведомления',
    aucune_notification: 'Нет уведомлений', tout_effacer: 'Очистить всё',
    deconnexion: 'Выйти', deconnexion_confirm: 'Вы уверены, что хотите выйти?',
    se_deconnecter: 'Выйти', factures_nav: 'Счета', cv_nav: 'Резюме',
    administration: 'Администрирование', utilisateurs: 'Пользователи',
    documents_nav: 'Документы', statistiques: 'Статистика',
    acces_admin: 'Доступ администратора',
    gerer_users_docs: 'Управление пользователями, документами и глобальной статистикой',
    rechercher_utilisateur: 'Поиск пользователя...', rechercher_document: 'Поиск документа или email...',
    utilisateur: 'Пользователь', role: 'Роль', inscription: 'Дата регистрации',
    actions: 'Действия', fichier: 'Файл', type: 'Тип',
    proprietaire: 'Владелец', date: 'Дата',
    aucun_utilisateur: 'Пользователь не найден', aucun_document_admin: 'Документ не найден',
    chargement: 'Загрузка...', succes: 'Успех', erreur: 'Ошибка',
    attention: 'Внимание', information: 'Информация',
    deconnexion_titre: 'Выход', changer_mdp: 'Изменить пароль',
    mdp_actuel: 'Текущий пароль', nouveau_mdp: 'Новый пароль',
    confirmer_mdp: 'Подтвердить пароль', activer_2fa: 'Включить 2FA',
    historique_connexion: 'История входов', fermer: 'Закрыть',
    cv_etape1: 'Моё резюме', cv_etape2: 'Вакансия и ИИ', cv_etape3: 'Предпросмотр и экспорт',
    cv_titre: 'Умное резюме', cv_sous_titre: 'Создайте резюме, оптимизированное для ATS',
    cv_infos_perso: 'Личная информация', cv_nom: 'Полное имя', cv_poste: 'Желаемая должность',
    cv_tel: 'Телефон', cv_ville: 'Город', cv_pays: 'Страна', cv_linkedin: 'LinkedIn',
    cv_resume: 'Профессиональное резюме', cv_experiences: 'Опыт работы',
    cv_ajouter_exp: 'Добавить опыт', cv_formations: 'Образование',
    cv_ajouter_form: 'Добавить образование', cv_competences: 'Навыки',
    cv_langues_cv: 'Языки', cv_template: 'Шаблон', cv_couleur: 'Цвет',
    cv_police: 'Шрифт', cv_telecharger: 'Скачать PDF', cv_telecharger_word: 'Скачать Word',
    cv_suivant: 'Далее', cv_precedent: 'Назад', cv_offre_emploi: 'Вакансия',
    cv_analyser: 'Анализировать и адаптировать', cv_analyse_ia: 'Анализ ИИ',
  },
};

export default t;